import { Table as ArcoTable } from "@arco-design/web-react";
import "./colorful-table.css";
import { useEffect, useState } from "react";

export const ColorfulTable = (props) => {
    const { className, components } = props;
    const [innerComponents, setInnerComponents] = useState(components ?? {});

    useEffect(() => {
        setInnerComponents((components) => {
            components.body = { ...components.body, row: ColorfulRow };
            return { ...components };
        });
    }, [])

    return (
        <ArcoTable {...props}
            components={innerComponents}
            className={`${className} colorful-table`} />
    )
}

const ColorfulRow = (props) => {
    const { children, className, record } = props;

    return (
        <tr className={`${className} colorful-tr`}>
            {children.map((child, index) => {
                const { column } = child.props;
                let bgColor = column?.bgColor ?? "Red";
                if (bgColor === "transparent") bgColor = null;
                if (column?.colorful && column.colorful(record)) {
                    return (
                        <td key={index}
                            className="arco-table-td"
                            style={{ backgroundColor: bgColor, color: bgColor ? "#FFF" : null }}>
                            <div className="arco-table-cell">
                                <span className="arco-table-wrapper-value">
                                    {column.render
                                        ? column.render(column, record)
                                        : column.dataIndex?.split('.').reduce((obj, key) => obj?.[key], record)
                                    }
                                </span>
                            </div>
                        </td>
                    )
                }
                return child
            })}
        </tr>
    )
}
